import { useMutation, useQueryClient } from '@tanstack/react-query';

import type {
  GetPlatformV1Users200,
  PatchPlatformV1UsersIdBody,
  PlatformUser,
} from '@nucleus-commerce/api-client/platform';

import { usersApi } from '../api/users-api';

import { userKeys } from './user-keys';

export interface UpdateUserInput {
  userId: string;
  body: PatchPlatformV1UsersIdBody;
}

/**
 * PATCH /platform/v1/users/:id. The bare user comes back and replaces its row in the cached list.
 * Callers pick the toast; the dialogs render errors themselves (422 self, 403 owner, 409 last owner).
 */
export function useUpdateUser(successMessage: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ userId, body }: UpdateUserInput) => usersApi.update(userId, body),
    meta: { successMessage, silentError: true },
    onSuccess: (user: PlatformUser) => {
      queryClient.setQueryData<GetPlatformV1Users200>(userKeys.list(), (previous) =>
        previous
          ? { items: previous.items.map((row) => (row.id === user.id ? user : row)) }
          : undefined,
      );
      return queryClient.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}
